export const columns = function () {
    return [
        {
            prop: 'insBillId',
            label: '内保单流水号',
            fixed: 'left',
            minWidth: 150
        },
        {
            prop: 'carNo',
            label: '车牌号',
            minWidth: 100
        },
        {
            prop: 'beginTime',
            label: '内保起期',
            sortable: true,
            minWidth: 100
        },
        {
            prop: 'endTime',
            label: '内保止期',
            sortable: true,
            minWidth: 100
        },
        {
            prop: 'status_name',
            label: '状态',   
            minWidth: 100
        },
        {
            prop: 'cusFee',
            label: '应交内保费（元）',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'cost',
            label: '退统费用',
            sortable: true,
            minWidth: 100
        },
        {
            prop: 'actual_cost',
            label: '实退金额',
            sortable: true,
            minWidth: 100
        },
        {
            prop: 'days',
            label: '退统天数',
            sortable: true,
            minWidth: 100
        },
        {
            prop: 'return_date',
            label: '退统时间',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'apply_name',
            label: '申请人',
            sortable: true,
            minWidth: 100
        },
        {
            prop: 'create_time',
            label: '申请时间',
            sortable: true,
            minWidth: 100
        },
        {
            prop: 'audit_name',
            label: '核审人',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'audit_time',
            label: '核审时间',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'finance_name',
            label: '财务核审人',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'finance_time',
            label: '财务审核时间',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'apply_remark',
            label: '备注',
            minWidth: 200
        },
        {
            prop: 'handle',
            label: '操作',
            minWidth: 150,
            fixed: 'right'
        }
    ]
}

export default {}